<template>
  <div>
    <span>
      <div style="display: inline-flex; margin-bottom: 0.75rem">
        <b-input class="code-input" v-model="offercode" @input="newcode()" />
        <button class="apply-btn" :disabled="isDisabled" @click="applySpecial()">Apply</button>
      </div>
    <!-- </span>
    <br />
    <span> -->
      <c-alert class='alert' v-if="special && applied" color="primary">{{
        this.special.description
      }}</c-alert>
      <c-alert class='alert' v-if="notfound && applied" color="danger"
        >The offer code {{ this.lastEnteredOffercode }} is not valid.</c-alert
      >
      <c-alert class="alert" v-if="expired" color="danger"
      >The offer code {{ this.lastEnteredOffercode }} has expired.</c-alert>
    </span>
  </div>
</template>

<script>
export default {
  name: "SpecialOffer",
  data: () => ({
    special: null,
    offercode: "",
    lastEnteredOffercode: "",
    notfound: false,
    applied: false,
    expired: false
  }),
  computed: {
    isDisabled() {
      // you can  check your form is filled or not here.
      return this.offercode === "";
    },
  },
  methods: {
    newcode() {
      this.special = null;
      this.applied = false;
      this.expired = false;
      this.$emit("applySpecial", null)
    },
    applySpecial() {
      this.applied = true
      this.lastEnteredOffercode = this.offercode
      this.notfound = false
      // ensure offercode != null
      if (this.offercode != null) {
        // if found then disable apply button
        this.$portalapi
          .get("/open/special/one/" + this.offercode)
          .then((response) => {
            // do something with both responses
            this.special = response.data;
            // today.getFullYear(), today.getMonth() + 1, 0
            if (new Date(this.special.availto) >= new Date()) {
              this.$emit("applySpecial", response.data);
            } else {
              this.special = null;
              this.expired = true;
            }
          })
          .catch((error) => {
            this.special = null;
            this.notfound = true;
            this.$emit("applySpecial", null);
            // offer code not found
          });
      } else {
        this.special = null;
        this.notfound = true;
        this.$emit("applySpecial", null);
      }

      
    }
  }
};
</script>

<style scoped>
 .apply-btn {
    border-radius: 6px 6px 6px 6px;
    margin-left: 0.25rem;
    height: 1.55rem;
    font-size: 10px;
    font-weight: 500;
    border: solid grey 2px;
    height: 2rem;
 } 

 .apply-btn:hover:enabled {
    border: solid #39123D 2px;
 }

 .code-input {
    height: 2rem;
    /* margin-top: 0.15rem; */
 }

</style>